import React from 'react';

import { AutomationRecommendationsBannerContent } from './automation-recommendations-banner-content';
import { AutomationRecommendationsContextProvider } from './automation-recommendations-context';

/**
 * @param {object} props
 * @param {boolean} props.roundCorners
 * @returns {ReactNode}
 */
export const AutomationRecommendationsBanner = ({ roundCorners = false }) => {
  return (
    <AutomationRecommendationsContextProvider>
      <AutomationRecommendationsBannerContent roundCorners={roundCorners} />
    </AutomationRecommendationsContextProvider>
  );
};
